(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-brand-ribbon"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.tp-brand-ribbon__toggle').forEach((button)=>{button.addEventListener('click',()=>{const ribbon=button.closest('.tp-brand-ribbon');const paused=ribbon.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);button.querySelector('span').textContent=paused?'▷':'Ⅱ';});});
  } catch(e) { console.error(e); }
})();

})();
